import { render, staticRenderFns } from "./SeafarerDocumentsQuery.vue?vue&type=template&id=6000ab5e"
import script from "./SeafarerDocumentsQuery.vue?vue&type=script&lang=ts"
export * from "./SeafarerDocumentsQuery.vue?vue&type=script&lang=ts"
import style0 from "./SeafarerDocumentsQuery.vue?vue&type=style&index=0&id=6000ab5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports